<template>
  <div class="calendar-date-selector">
    <span @click="selectPrevious"><v-icon size="30" color="rgba(0, 0, 0, 0.6)">mdi-chevron-left</v-icon></span>
    <span @click="selectCurrent" style="padding: 0px 15px"><v-icon size="30" color="rgba(0, 0, 0, 0.6)">mdi-calendar-today</v-icon></span>
    <span @click="selectNext"><v-icon size="30" color="rgba(0, 0, 0, 0.6)">mdi-chevron-right</v-icon></span>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import dayjs from "dayjs";

export default {
  name: "CalendarModeSelector",
  props: {
    currentDate: {
      type: String,
      required: true
    },

    selectedDate: {
      type: Object,
      required: true
    }
  },

  methods: {
    selectPrevious() {
      const newSelectedDate = dayjs(this.selectedDate).locale('pt-br').subtract(1, "month");
      this.$emit("dateSelected", newSelectedDate);
    },
    selectCurrent() {
      const newSelectedDate = dayjs(this.currentDate).locale('pt-br');
      this.$emit("dateSelected", newSelectedDate);
    },
    selectNext() {
      const newSelectedDate = dayjs(this.selectedDate).locale('pt-br').add(1, "month");
      this.$emit("dateSelected", newSelectedDate);
    }
  }
};
</script>

<style scoped>
.calendar-date-selector {
  display: flex;
  justify-content: space-between;
  color: var(--grey-800);
  padding-top: 2px
}

.calendar-date-selector > * {
  cursor: pointer;
  user-select: none;
}
</style>
